<template>
    <h4>{{title}}</h4>
    <p>{{desc}}</p>
    <p class="usedTech">{{usedTech}}</p>
</template>

<script>
export default {
    name: "ProjectInfo",
    props: ['title', 'desc', 'usedTech']
}
</script>

<style scoped lang="scss">
h4 {
        margin: 0 0 0.4rem 3rem;
        font-weight: 500;
        font-size: 1.15rem;
      }

      p {
        margin: 0 0 0.6rem 3rem;
        font-size: 0.95rem;
      }

      @media(min-width: 2250px) {

        h4 {
        margin: 0 0 0.7rem 3rem;
        font-size: 1.45rem;
      }

        p {
          margin: 0 0 0.2rem 3rem;
          font-size: 1.15rem;
      }

      .usedTech {
        margin: 0 0 0.8rem 3rem;
      }
      }

      @media(max-width: 1024px) {
          h4 {
            margin: 0 0 0.4rem 2.5rem;
          }

          p {
            margin: 0 0 0.2rem 2.5rem;
          }
      }

      @media(max-width:768px) {

        h4 {
          margin: 0 0 0.35rem 2rem;
          font-size: 1.10rem;
        }

        p {
            margin: 0 0 0.3rem 2rem;
            font-size: 0.9rem;
        }

        .usedTech {
          display: none;
        }
      }

      @media(max-width:350px) {
      h4, p{
        h4, p{
        margin-left: 1.5rem;
      }
      }
      }
</style>